import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import moment from "moment";

import ReportService from "../../../services/report-service/ReportService";
import Utili from "../../../utility/Utility";
import SpinnerLoader from "../../../components/spinner-loader/SpinnerLoader.component";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

function MessageResponsivenessReport() {
  const classes = useStyles();

  /* Helpers */
  const getInitialDate = (days: number) => {
    const d = new Date();
    d.setDate(d.getDate() + days);
    return moment(d).format("YYYY-MM-DD");
  };

  const parseDate = (dt: Date) =>
    new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());

  const CurrentDate = () => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  };

  /* State */
  const [selectedFromDate, setSelectedFromDate] = useState(getInitialDate(-30));
  const [selectedToDate, setSelectedToDate] = useState(getInitialDate(0));
  const [validationMessage, setValidationMessage] = useState("");
  const [isValidate, setIsValidate] = useState(false);

  const [selectedCaller, setSelectedCaller] = useState("Caller");
  const [selectedRole, setSelectedRole] = useState("all");
  const [selectedUserName, setSelectedUserName] = useState("");

  const [reportData, setReportData] = useState("");
  const [pdfBytes, setPdfBytes] = useState("");
  const [showDownloadBtn, setShowDownloadBtn] = useState(false);

  /* Handlers */
  const handleFromDateChange = (e: any) => {
    setSelectedFromDate(e.target.value);
  };

  const handleToDateChange = (e: any) => {
    setSelectedToDate(e.target.value);
  };

  const handleUserName = (e: any) => {
    setSelectedUserName(e.target.value);
  };

  const handleChangeCaller = (e: any) => {
    setSelectedCaller(e.target.value);
  };

  const handleChangeRole = (e: any) => {
    setSelectedRole(e.target.value);
  };

  /* Actions */
  const gettReport = () => {
    if (
      parseDate(new Date(selectedFromDate)) > CurrentDate() ||
      parseDate(new Date(selectedToDate)) > CurrentDate()
    ) {
      setIsValidate(true);
      setValidationMessage("From Date and To Date cannot be in future");
      return;
    }

    if (new Date(selectedFromDate) > new Date(selectedToDate)) {
      setIsValidate(true);
      setValidationMessage("From Date cannot be after To Date");
      return;
    }

    setIsValidate(false);
    setValidationMessage("");

    const safeFrom = moment(selectedFromDate)
      .startOf("day")
      .format("MM/DD/YYYY hh:mm:ss A");

    const safeTo = moment(selectedToDate)
      .endOf("day")
      .format("MM/DD/YYYY hh:mm:ss A");

    ReportService.getMessageResponsivenessReport(
      safeFrom,
      safeTo,
      selectedCaller,
      0,
      selectedRole,
      selectedUserName
    ).then((res: any) => {
      setReportData(res?.data?.result?.reportHTML ?? "");
      setPdfBytes(res?.data?.result?.reportBytes ?? "");
      setShowDownloadBtn(true);
    });
  };

  const ClearSearchCriteria = () => {
    setSelectedFromDate(getInitialDate(-30));
    setSelectedToDate(getInitialDate(0));
    setSelectedCaller("Caller");
    setSelectedRole("all");
    setSelectedUserName("");
    setValidationMessage("");
    setIsValidate(false);
    setReportData("");
    setShowDownloadBtn(false);
  };

  const Download = () => {
    const blob = Utili.b64toBlob(pdfBytes);
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "MessageResponsivenessReport";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="col-12">
      <SpinnerLoader
        isGeneral={true}
        tasksList={["GetMessageReportResponsiveness"]}
        inInternal={false}
      />

      <h3>Message Responsiveness Report</h3>

      {/* DATE FILTERS */}
      <form className={classes.container} noValidate>
        <TextField
          label="From Date"
          type="date"
          value={selectedFromDate}
          onChange={handleFromDateChange}
          InputProps={{ inputProps: { max: selectedToDate } }}
          className={classes.textField}
          InputLabelProps={{ shrink: true }}
        />

        <TextField
          label="To Date"
          type="date"
          value={selectedToDate}
          onChange={handleToDateChange}
          className={classes.textField}
          InputLabelProps={{ shrink: true }}
        />
      </form>

      {/* USER TYPE */}
      <div className="p-2 mt-2 mr-3 float-left">
        <div className="label-bx">
          <h5>User Type</h5>
        </div>
        <div className="custom-control custom-radio custom-control-inline">
          <input
            type="radio"
            value="Caller"
            onChange={handleChangeCaller}
            checked={selectedCaller === "Caller"}
            id="Caller"
            name="role"
            className="custom-control-input"
          />
          <label className="custom-control-label" htmlFor="Caller">
            Sender
          </label>
        </div>
        <div className="custom-control custom-radio custom-control-inline">
          <input
            type="radio"
            value="Recipient"
            onChange={handleChangeCaller}
            checked={selectedCaller === "Recipient"}
            id="Recipient"
            name="role"
            className="custom-control-input"
          />
          <label className="custom-control-label" htmlFor="Recipient">
            Recipient
          </label>
        </div>
      </div>

      {/* SUBSCRIPTION TYPE */}
      <div className="p-2 mt-2 float-left">
        <div className="label-bx">
          <h5>Subscription Type</h5>
        </div>
        <div className="custom-control custom-radio custom-control-inline">
          <input
            type="radio"
            value="all"
            onChange={handleChangeRole}
            checked={selectedRole === "all"}
            id="all"
            name="sub"
            className="custom-control-input"
          />
          <label className="custom-control-label" htmlFor="all">
            All
          </label>
        </div>
        <div className="custom-control custom-radio custom-control-inline">
          <input
            type="radio"
            value="standard"
            onChange={handleChangeRole}
            checked={selectedRole === "standard"}
            id="standard"
            name="sub"
            className="custom-control-input"
          />
          <label className="custom-control-label" htmlFor="standard">
            Standard
          </label>
        </div>
        <div className="custom-control custom-radio custom-control-inline">
          <input
            type="radio"
            value="premium"
            onChange={handleChangeRole}
            checked={selectedRole === "premium"}
            id="premium"
            name="sub"
            className="custom-control-input"
          />
          <label className="custom-control-label" htmlFor="premium">
            Premium
          </label>
        </div>
      </div>

      {/* NAME */}
      <div className="p-2 mt-2 float-left">
        <div className="label-bx">
          <h5>Name</h5>
        </div>
        <input
          className="form-control form-control-sm"
          type="text"
          value={selectedUserName}
          onChange={handleUserName}
          placeholder="Name"
          style={{ backgroundColor: "#fff" }}
        />
      </div>

      {/* ACTIONS */}
      <div className="mt-4 float-left">
        <button
          type="button"
          onClick={ClearSearchCriteria}
          className="btn btn-sm search-btn stnd-btn view-r-btn"
        >
          Reset
        </button>
        <button
          type="button"
          onClick={gettReport}
          className="btn btn-sm search-btn stnd-btn view-r-btn"
        >
          View Report
        </button>

        <div className="clearfix" />
        {isValidate && (
          <span className="error-msg" style={{ color: "#ff0000" }}>
            {validationMessage}
          </span>
        )}
      </div>

      <div className="clearfix" />

      {/* REPORT */}
      <div className="mt-4">
          <div className="mb-0 heading">
        <h5>
          Report
          {showDownloadBtn && (
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary float-right"
              onClick={Download}
            >
              Save as
            </button>
          )}
        </h5>
</div>
        <div className="report-view-bx">
          <div dangerouslySetInnerHTML={{ __html: reportData }} />
        </div>
      </div>
    </div>
  );
}

export default MessageResponsivenessReport;
